import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";
import { formatDuration, formatViews } from "@/utils/format";

export default function VideoCard({ video }: { video: VideoItem }) {
  return (
    <Link
      to={`/video-detail/${video.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-700"
    >
      <div className="relative aspect-video w-full overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} - ${video.category}视频封面`}
          title={`${video.title} ${video.category} 成人视频`}
          className="h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
        <span className="absolute left-2.5 top-2.5 rounded bg-background-950/70 px-1.5 py-0.5 text-[10px] tracking-wide text-foreground-800">
          {video.resolution}
        </span>
        <span className="absolute bottom-2.5 right-2.5 rounded bg-background-950/75 px-1.5 py-0.5 font-mono text-[11px] text-foreground-800">
          {formatDuration(video.durationMinutes)}
        </span>
        <span className="absolute bottom-2.5 left-2.5 flex h-8 w-8 items-center justify-center rounded-full bg-primary-500/90 text-sm text-background-50 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <i className="ri-play-fill"></i>
        </span>
      </div>
      <div className="p-3">
        <h3 className="line-clamp-2-safe text-sm font-medium leading-relaxed text-foreground-950 transition-colors group-hover:text-accent-500">
          {video.title}
        </h3>
        <div className="mt-2 flex items-center justify-between text-[11px] text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-play-circle-line"></i>
            {formatViews(video.views)}
          </span>
          <span>{video.category}</span>
        </div>
      </div>
    </Link>
  );
}